import { useEffect, useState } from "react";
import { getHashdata } from "../components/Tabs/Utils/hashFunctions";

const readHashValue = (key) => {
  const raw = getHashdata(window.location.hash, key);
  if (raw == null) return "";
  try {
    return decodeURIComponent(raw);
  } catch {
    return raw;
  }
};

/**
 * One key of the URL hash, kept current as it changes.
 *
 * The tab components write their selection straight onto
 * window.location.hash rather than through the router (see NavTabs'
 * handleChange and hashFunctions' setHash), so useLocation never sees those
 * writes - but the browser still fires "hashchange" for them, which is what
 * this listens to. For reading which tab is open from outside the tabs
 * themselves.
 */
export default function useHashValue(key) {
  const [value, setValue] = useState(() => readHashValue(key));

  useEffect(() => {
    const sync = () => setValue(readHashValue(key));
    sync();
    window.addEventListener("hashchange", sync);
    return () => window.removeEventListener("hashchange", sync);
  }, [key]);

  return value;
}
